// import the files
import { mapValues } from 'lodash';

import workatoSiteSettings, { PATH as workatoSiteSettingsPath } from './workato-configuration';
import medalliaSiteSettings, { PATH as medalliaSiteSettingsPath } from './medallia-configuration';
import shell, { PATH as shellPath } from './shell';
import skills, { PATH as skillPath } from './skills';
import partners, { PATH as partnersPath } from './partners';

const MODULE_PREFIX = 'data';

const dataModules = {
  namespaced: true,
  modules: {
    workatoSiteSettings,
    medalliaSiteSettings,
    shell,
    skills,
    partners,
  },
};
export default dataModules;

export const MODULES_PATHS = mapValues(
  {
    ...workatoSiteSettingsPath,
    ...medalliaSiteSettingsPath,
    ...shellPath,
    ...skillPath,
    ...partnersPath,
  },
  path => `${MODULE_PREFIX}/${path}`,
);
